import React from 'react';
import './style.scss';

const MainLayout = ({ children }) => (
  <div className="main-layout">
    {children}
  </div>
);

export { MainLayout };



// WEBPACK FOOTER //
// ./src/view/common/Layout/index.jsx